import { BookingFormMode } from "PFApp/booking/components/booking_form/booking_form.types";
import { useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import { HandleFillAndBookParams, useFillAndBook } from "PFApp/hooks/use_fill_and_book";
import { useEffect } from "react";

type UseFillAndBookCustomReturn = {
  isLoading: boolean;
  handleCustomFillAndBook: (params: Omit<HandleFillAndBookParams, "shortlistId">) => void;
};

export const useFillAndBookCustom = (): UseFillAndBookCustomReturn => {
  const { openBookingFormSidePanel, closeBookingFormSidePanel } = useDetailsPanelsActions();

  // Close booking form if action is not available anymore
  useEffect(
    () => () => {
      closeBookingFormSidePanel();
    },
    []
  );

  const { isLoading, handleFillAndBookAction } = useFillAndBook();

  const handleCustomFillAndBook = ({
    activity,
    profileId,
    vacancyId,
    named = true
  }: Omit<HandleFillAndBookParams, "shortlistId">) => {
    openBookingFormSidePanel(
      {
        profileId: Number(profileId),
        activityId: activity.id,
        isProfileMatched: !named
      },
      {
        mode: BookingFormMode.Create,
        customPreSubmitAction: async (shortlistId) => {
          if (!shortlistId) {
            return;
          }
          // `fill_and_book` needs to be called before `booking_module/bookings` to avoid race condition
          // there are some asynchronous actions in `booking_module/bookings` related to vacancies
          return await handleFillAndBookAction(
            { activity, profileId, shortlistId, vacancyId },
            true,
            (errorResponse) => {
              throw errorResponse;
            }
          );
        }
      }
    );
  };

  return {
    isLoading,
    handleCustomFillAndBook
  };
};
